import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = process.env.REACT_APP_SITE_URL;
const DEFAULT_IMAGE = `${SITE_URL}/og-cover.jpg`;
const DEFAULT_KEYWORDS = "Andaman tour packages, Andaman Nicobar tour, Port Blair, Havelock Island, Neil Island, Baratang, Ross Island, Andaman honeymoon package, Andaman family package";

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

export const Seo = ({ title, description, path = "/", image, keywords, type = "website", jsonLd = [], noindex = false }) => {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  useEffect(() => {
    document.querySelectorAll("head [data-static-seo]").forEach((n) => n.remove());
    document.querySelectorAll("head title").forEach((n) => n.textContent !== title && n.remove());
  }, [title]);
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Ocean Wings Travel" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((j, i) => <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>)}
    </Helmet>
  );
};
